import { gql } from "@apollo/client";

export const UpdateInstalledBaseEvent = gql`
    mutation UpdateInstalledBaseEvent($eventId: ID!, $input: InstalledBaseEventUpdateInput) {
        updateInstalledBaseEvent(eventId: $eventId, input: $input) {
            id
        }
    }
`;
